function App() {
  return (
    <mian className='App'>
      <div class='container py-5 mb-5'>
        <h1 className='mb-5 text-center'>React Project Collections</h1>
        <div class='row row-cols-1 row-cols-md-2 row-cols-lg-3 g-5'>
          <div class='col'>
            <div class='card shadow border-0'>
              <img
                src='https://firebasestorage.googleapis.com/v0/b/testtest-d2997.appspot.com/o/img%2Fbirthday-min.jpeg?alt=media&token=d91dc529-4ae7-4c3e-9620-7956f8dec6bb'
                class='card-img-top'
                alt='project'
              />
              <div class='card-body'>
                <h5 class='card-text text-center'>Birthday Reminder</h5>
                <a
                  href='https://ted-birthday-reminder.netlify.app'
                  target='blank'
                  class='stretched-link'></a>
              </div>
            </div>
          </div>
          <div class='col'>
            <div class='card shadow border-0'>
              <img
                src='https://firebasestorage.googleapis.com/v0/b/testtest-d2997.appspot.com/o/img%2Ftours.jpeg?alt=media&token=beb6d1ef-a6a8-424f-be95-0f417bab8185'
                class='card-img-top'
                alt='project'
              />
              <div class='card-body'>
                <h5 class='card-text text-center'>Tours</h5>
                <a
                  href='https://ted-tours.netlify.app/'
                  target='blank'
                  class='stretched-link'></a>
              </div>
            </div>
          </div>
          <div class='col'>
            <div class='card shadow border-0'>
              <img
                src='https://firebasestorage.googleapis.com/v0/b/testtest-d2997.appspot.com/o/img%2FReviews.jpeg?alt=media&token=fefbccf1-050c-49c6-96fb-70fccc279a8f'
                class='card-img-top'
                alt='project'
              />
              <div class='card-body'>
                <h5 class='card-text text-center'>Reviews</h5>
                <a
                  href='https://ted-reviews.netlify.app/'
                  target='blank'
                  class='stretched-link'></a>
              </div>
            </div>
          </div>
          <div class='col'>
            <div class='card shadow border-0'>
              <img
                src='https://firebasestorage.googleapis.com/v0/b/testtest-d2997.appspot.com/o/img%2Faccordion.jpeg?alt=media&token=51c06198-d376-4c5b-ab21-8a623c7c62a4'
                class='card-img-top'
                alt='project'
              />
              <div class='card-body'>
                <h5 class='card-text text-center'>Accordion</h5>
                <a
                  href='https://ted-accordion.netlify.app/'
                  target='blank'
                  class='stretched-link'></a>
              </div>
            </div>
          </div>
          <div class='col'>
            <div class='card shadow border-0'>
              <img
                src='https://firebasestorage.googleapis.com/v0/b/testtest-d2997.appspot.com/o/img%2FMenu.jpeg?alt=media&token=3ef20be7-6d0b-41b2-b57d-9576b481b7b9'
                class='card-img-top'
                alt='project'
              />
              <div class='card-body'>
                <h5 class='card-text text-center'>Menu</h5>
                <a
                  href='https://ted-menu.netlify.app/'
                  target='blank'
                  class='stretched-link'></a>
              </div>
            </div>
          </div>
          <div class='col'>
            <div class='card shadow border-0'>
              <img
                src='https://firebasestorage.googleapis.com/v0/b/testtest-d2997.appspot.com/o/img%2Ftabs.jpeg?alt=media&token=d5fb66fd-1f7c-446d-84a7-5a687e0dff2d'
                class='card-img-top'
                alt='project'
              />
              <div class='card-body'>
                <h5 class='card-text text-center'>tabs</h5>
                <a
                  href='https://ted-tabs.netlify.app/'
                  target='blank'
                  class='stretched-link'></a>
              </div>
            </div>
          </div>
          <div class='col'>
            <div class='card shadow border-0'>
              <img
                src='https://firebasestorage.googleapis.com/v0/b/testtest-d2997.appspot.com/o/img%2Fslider.jpeg?alt=media&token=51e4dd10-42c7-4edd-9313-0658721e6f33'
                class='card-img-top'
                alt='project'
              />
              <div class='card-body'>
                <h5 class='card-text text-center'>Slider</h5>
                <a
                  href='https://ted-slider.netlify.app/'
                  target='blank'
                  class='stretched-link'></a>
              </div>
            </div>
          </div>
          <div class='col'>
            <div class='card shadow border-0'>
              <img
                src='https://firebasestorage.googleapis.com/v0/b/testtest-d2997.appspot.com/o/img%2Florem-ipsum.jpeg?alt=media&token=a36a7f77-a07c-410b-ad65-9cf596aae502'
                class='card-img-top'
                alt='project'
              />
              <div class='card-body'>
                <h5 class='card-text text-center'>Lorem Ipsum</h5>
                <a
                  href='https://ted-lorem-ipsum.netlify.app/'
                  target='blank'
                  class='stretched-link'></a>
              </div>
            </div>
          </div>
          <div class='col'>
            <div class='card shadow border-0'>
              <img
                src='https://firebasestorage.googleapis.com/v0/b/testtest-d2997.appspot.com/o/img%2Fcolor-generator.jpeg?alt=media&token=5cdf7471-25b1-4f54-ba11-5c449e10886b'
                class='card-img-top'
                alt='project'
              />
              <div class='card-body'>
                <h5 class='card-text text-center'>Color Generator</h5>
                <a
                  href='https://ted-color-generator.netlify.app/'
                  target='blank'
                  class='stretched-link'></a>
              </div>
            </div>
          </div>
          <div class='col'>
            <div class='card shadow border-0'>
              <img
                src='https://firebasestorage.googleapis.com/v0/b/testtest-d2997.appspot.com/o/img%2Fgrocery-bud.jpeg?alt=media&token=963585ac-f5d5-4eab-9f0a-5df45cb26b68'
                class='card-img-top'
                alt='project'
              />
              <div class='card-body'>
                <h5 class='card-text text-center'>Grocery Bud</h5>
                <a
                  href='https://ted-grocery-bud.netlify.app/'
                  target='blank'
                  class='stretched-link'></a>
              </div>
            </div>
          </div>
          <div class='col'>
            <div class='card shadow border-0'>
              <img
                src='https://firebasestorage.googleapis.com/v0/b/testtest-d2997.appspot.com/o/img%2Fnavbar.jpeg?alt=media&token=c9517c35-09fc-4bd7-846d-3379c2f682d2'
                class='card-img-top'
                alt='project'
              />
              <div class='card-body'>
                <h5 class='card-text text-center'>Navbar</h5>
                <a
                  href='https://ted-navbar.netlify.app/'
                  target='blank'
                  class='stretched-link'></a>
              </div>
            </div>
          </div>
          <div class='col'>
            <div class='card shadow border-0'>
              <img
                src='https://firebasestorage.googleapis.com/v0/b/testtest-d2997.appspot.com/o/img%2Fsidebar-modal.jpeg?alt=media&token=5da80449-194f-4966-973d-0a963559e73b'
                class='card-img-top'
                alt='project'
              />
              <div class='card-body'>
                <h5 class='card-text text-center'>Sidebar Modal</h5>
                <a
                  href='https://ted-sidebar-modal.netlify.app/'
                  target='blank'
                  class='stretched-link'></a>
              </div>
            </div>
          </div>
          <div class='col'>
            <div class='card shadow border-0'>
              <img
                src='https://firebasestorage.googleapis.com/v0/b/testtest-d2997.appspot.com/o/img%2Fstripe-submenus.jpeg?alt=media&token=7442cd07-2e67-431a-bcc2-e50c570da4b1'
                class='card-img-top'
                alt='project'
              />
              <div class='card-body'>
                <h5 class='card-text text-center'>Stripe Submenus</h5>
                <a
                  href='https://ted-stripe-submenus.netlify.app/'
                  target='blank'
                  class='stretched-link'></a>
              </div>
            </div>
          </div>
          <div class='col'>
            <div class='card shadow border-0'>
              <img
                src='https://firebasestorage.googleapis.com/v0/b/testtest-d2997.appspot.com/o/img%2Fcart.jpeg?alt=media&token=147114bd-e9cf-4275-8bcf-b200df156ec7'
                class='card-img-top'
                alt='project'
              />
              <div class='card-body'>
                <h5 class='card-text text-center'>Cart</h5>
                <a
                  href='https://ted-cart.netlify.app/'
                  target='blank'
                  class='stretched-link'></a>
              </div>
            </div>
          </div>
          <div class='col'>
            <div class='card shadow border-0'>
              <img
                src='https://firebasestorage.googleapis.com/v0/b/testtest-d2997.appspot.com/o/img%2Fcocktails.jpeg?alt=media&token=e9bd7cbe-8be1-4f76-b231-cfae9d3d2f76'
                class='card-img-top'
                alt='project'
              />
              <div class='card-body'>
                <h5 class='card-text text-center'>Cocktails</h5>
                <a
                  href='https://ted-cocktails.netlify.app/'
                  target='blank'
                  class='stretched-link'></a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer className='bg-dark text-light py-3'>
        <ul className='list-unstyled text-center'>
          <li className="mb-2">
            <a
              className='h5 '
              target='blank'
              href='https://github.com/ted31539/react-project-collections'>
              GitHub
            </a>
          </li>
          <li className="h5 mb-2">蔡岳宏 作品</li>
          <li className="h5 mb-2">ted31539@gmail.com</li>
        </ul>
      </footer>
    </mian>
  );
}

export default App;
